import React, { Component, Fragment, useEffect } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import { GET_ANALYTICS_DATA } from "../../queries";
import { useQuery } from "@apollo/client";

import animetionLogo from "../../assets/utils/images/animetion_logo.gif";

// Examples
import AnalyticsOrgDashboard from "./AnalyticsOrg";
import { useMyOrgInfo } from "../../Layout/AppMain/LoginStatusContext";

const AnalyticsDashboard = ({ orgId }) => {
  if ("このユーザーは団体と紐づいていません" == orgId) {
    window.location.href = "/#/dashboards/faq";
  }
  const myOrgInfo = useMyOrgInfo();
  const myOrgId = myOrgInfo.id;

  useEffect(() => {
    if (myOrgId || loading) {
    } else {
      alert(
        "このページを利用するには「組織登録」が必要です。\n詳しくはFAQをご覧ください。"
      );
      window.location.href = "/#/dashboards/faq";
    }
  }, []);

  // analytics クエリ
  const { loading, error, data, refetch } = useQuery(GET_ANALYTICS_DATA, {
    variables: { orgPk: orgId },
  });
  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    alert("ログイン制限時間が切れました、再リロードしてください。");
    window.location.href = "/#/dashboards/journy";
  }
  if (!data) return "...Not Found";

  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <AnalyticsOrgDashboard data={data} refetch={refetch} />
      </CSSTransitionGroup>
    </Fragment>
  );
};

export default AnalyticsDashboard;
